import { createSelector } from '@ngrx/store';

import { HotelDetailModuleState } from '@hotels/hotel-detail/store/state/hotel-detail-module.state';
import { hotelDetailRootSelector } from '@hotels/hotel-detail/store/selectors/hotel-detail-root.selector';
import { HotelSearched } from '@hotels/hotel-results/entities/hotel-searched';

export const getHotelDetailSearchedState = createSelector(
  hotelDetailRootSelector,
  (state: HotelDetailModuleState) => state.hotelDetailSearched
);

export const hotelDetailSearchedSelector = createSelector(getHotelDetailSearchedState, (state: HotelSearched) => state);
